import GronzePage from "../components/GronzePage";
import AppService from "./AppService";
import type { ReactElement, ReactNode } from "react";

class GronzePageService {

    static componentOpenHandler: (component: ReactNode) => Promise<void>;
    static componentCloseHandler: () => void;

    /**
     * method needed to connect page component with tha app
     */
    static init(): void {
        this.componentOpenHandler = AppService.appcomponent.handleOpenPage;
        this.componentCloseHandler = AppService.appcomponent.handleClosePage;
    }

    /**
     * open page
     */
    static getPage(component: ReactNode): ReactElement {
        return <GronzePage component={component}/>;
    }
}

export default GronzePageService;
